import React from 'react';
import { useSelector } from "react-redux";

import FaveWatchOffCanvas from "./FaveWatch/FaveWatchOffCanvas";
import FaveReadOffCanvas from "./FaveRead/FaveReadOffCanvas";
import FaveLearnOffCanvas from "./FaveLearn/FaveLearnOffCanvas";
import FavouritesContent from "./FavouritesContent";

import useFavourites from './useFavourites';
import "./Favourites_slick.css";

export default function Favourites(props) {

    const {
        faveOffCanvasToggled,
        faveWatchOffCanvasIsActive,
        faveReadOffCanvasIsActive,
        faveLearnOffCanvasIsActive
    } = useSelector((state) => state.navBar);

    const { noFaves } = useFavourites();

    const scrollStatus = ((!faveOffCanvasToggled && !noFaves) ? " overflow-y-scroll " : " ");

    return (
        <>
            {!faveOffCanvasToggled && (
                <div className={`favourites h-full col-start-8 3xl:col-start-7 col-end-25 bg-purple-dashboard flex ${scrollStatus} flex-col gap-y-6 text-white `}>
                    <FavouritesContent noFaves={noFaves} />
                </div>
            )}

            { faveWatchOffCanvasIsActive && <FaveWatchOffCanvas /> }
            { faveLearnOffCanvasIsActive && <FaveLearnOffCanvas /> }
            { faveReadOffCanvasIsActive && <FaveReadOffCanvas /> }
        </>
    );
}






